import React from 'react'
//import { Button } from 'reakit'
import styled from "@emotion/styled";
import { Link, navigate } from 'gatsby'
//import { handleLogin, logout, isLoggedIn } from "../../server/auth"
import Auth0Lock from 'auth0-lock';
import {Auth0LockPasswordless} from 'auth0-lock';
import {createCustomer, getInventory} from "../stripe/functions";
import {fonts} from "../../styles/variables";
const userIcon = require('../../../assets/images/user.svg')
const authLogo = require('../../../assets/images/V7_000_Logo.png');
var moment = require('moment');
import { FormattedMessage } from 'react-intl';

const styledUserIcon= styled(userIcon)`

margin:auto;
`

const NextButton = styled.div`
cursor:pointer;
width:100%;
margin-left:auto;
margin-right:auto;
margin-bottom:10px;
margin-top:20px;  
height:45px !important;
border-radius:4px;
display:flex;
background:#daac00;
letter-spacing:2px;
font-weight:bold;
font-size:19px;
 justify-content:center;
 transition:all .7s ease;
 

`

const A = styled.div`
display:flex;
justify-content:center;
align-items:center;
color:white;
`
let options = {
  container: 'pop-lock-container',
  allowLogin: false,
  theme: {
    logo: authLogo,
    primaryColor: '#188cec'

  },

  languageDictionary: {
    title: "You are about to complete your booking.",
    emailInputPlaceholder: "Email adress",
    usernameInputPlaceholder: "Full name",
    passwordInputPlaceholder: "Password",
    signUpTitle: 'You are about to complete your booking.'

  },
  auth: {
    redirect: false
  },
  rememberLastLogin: true,

    allowAutocomplete: true,
    allowShowPassword: true


};

// initialize

// render

const Div = styled.div`
 font-family: "Theano Didot",Regular !important;

 .auth0-lock.auth0-lock .auth0-lock-input-wrap .auth0-lock-icon, .auth0-lock.auth0-lock .auth0-lock-input-wrap .auth0-lock-custom-icon{
font-family: Theano Didot;
font-style: italic;
 }
 
  .auth0-lock-input{
 font-family: Theano Didot;
font-style: italic;
 } 
  

 
 auth0-lock-alternative-link{
  font-family: Theano Didot;
font-style: italic;
 }
 
.auth0-loading{
left:44.5% !important;
  
}

.auth0-lock-content-wrapper{

}

.auth0-lock-tabs{
font-family: ${fonts.button}; 
text-transform:uppercase !important; 
font-size:16px !important;
}

 
 .auth0-lock.auth0-lock .auth0-lock-header-bg{
 background:white !important;
 filter:none;

 }
 
.auth0-lock-name {
font-family: Theano Didot;
font-style: italic;
 @media screen and (max-width: 860px) {
 font-size:16px;
}
}
 
 .auth0-lock.auth0-lock .auth0-lock-widget {
width:100%;
border:none !important;
 
 
 }
 
 .auth0-lock.auth0-lock .auth0-lock-close-button, .auth0-lock.auth0-lock .auth0-lock-back-button{
 height:25px;
 width:25px;
 color:rgb(68,68,68);
 left: 0px;
top: -9px;
 
 }
 
 .auth0-lock.auth0-lock .auth0-lock-header{
 padding-top:0px;
 }
.auth0-lock.auth0-lock .auth0-lock-header-bg{
 background-color:white !important;
 opacity:0 !important;
 filter: none !important;
 background-image:none !important ;
 }
 .auth0-lock-form{

 }
 
 
 
 .modal > .close {
  cursor: pointer;
  position: absolute;
  display: block;
  padding: 2px 5px;
  line-height: 20px;
  right: -10px;
  top: -10px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #cfcece;
}

.auth0-lock-social-button{
border-radius:2px !important;
}

.auth0-lock-social-button[data-provider="google-oauth2"]{
background:rgba(68,68,68,.5) !important;



}

.auth0-lock-social-button[data-provider^="google"] .auth0-lock-social-button-icon{


}

.auth0-lock.auth0-lock .auth0-lock-submit{
//text-transform:none !important;
}
.auth0-lock-submit{
font-family: ${fonts.button}; 
text-transform:uppercase !important;
font-weight:bold;
border-bottom:2px solid #188cec; 
border-right:2px solid #188cec;
height:45px !important;
display:flex;
justify-content:center; 
align-items:center;
font-size:18px !important;
letter-spacing:2px !important;
transition: all .7 ease !important;

 justify-content:center;
  border-radius: 10rem !important;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;

  
:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: #188cec;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #54aaf1;
  border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: #fff;
}
 
:hover:before {
  width: 100%;
}

}

}
.auth0-lock.auth0-lock .auth0-lock-submit .auth0-label-submit{
line-height:10px !important;
}
.auth0-lock.auth0-lock .auth0-lock-submit .auth0-label-submit{
line-height: auto !important;
height:auto !important;
padding-bottom:3px;
}

.auth0-lock.auth0-lock .auth0-lock-submit .auth0-label-submit{
transition:all 0.7 ease !important;
}

.auth0-lock-terms{
display:none !important;
}
.auth0-lock.auth0-lock .auth0-lock-submit:hover:not([disabled]) span{
transform: none;
//letter-spacing:2px;
}
.auth0-lock-social-button-text {
font-size:12px !important;
letter-spacing:1px !important; 
font-family:${fonts.button}
}

.auth0-lock.auth0-lock .auth0-lock-social-button[data-provider="google-oauth2"].auth0-lock-social-big-button .auth0-lock-social-button-text{
color:white !important;

:hover{
color:white !important;
background:rgba(68,68,68,.7) !important;
}



}

.auth0-lock.auth0-lock .auth0-lock-submit{
padding:10px !important;


}

`
let lock;
export class PopLock extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = { open: false }

  }



  async componentDidMount(){

    lock = await new Auth0Lock(

      'YY3uCnLuNwtYJ8w3S6Wdq5Z8bH7mD2GK',
      'dev-uv101.eu.auth0.com',
      options



    );
    lock.show();


    lock.on("authenticated", function(authResult) {
      lock.getUserInfo(authResult.accessToken, function(error, profile) {
        if (error) {
          // Handle error
          return;
        }

        //  if(profile.user_metadata.stripe_customer_id === undefined){

        //console.log(authResult)
        //console.log(profile)

        //  var stripe = require('stripe')('pk_test_hA3jp8pO55qLPWtne9PAZGjn00latb2uzt');
        var customer = {
          email: profile.email
        };

        /*  stripe.customers.create(customer, function(err, customer) {
            if (err) {
            //  return callback(err);
            }

            profile.user_metadata.stripe_customer_id = customer.id;

            var request = require("request");

            var options = { method: 'PATCH',
              url: 'https://dev-uv101.eu.auth0.com/api/v2/users/'+profile.sub,
              headers:
                { 'content-type': 'application/json',
                  authorization: 'Bearer ABCD' },
              body:
                { user_metadata: { stripe_customer_id: customer.id } },
              json: true };

            request(options, function (error, response, body) {
              if (error) throw new Error(error);

              console.log(body);
            });

          });
          */
        //  }



        createCustomer(profile.email, profile.name, profile.sub, authResult.accessToken).catch((err) => { // Error response
          //console.log(err);
        });


        //console.log('TESTER')

        let now = moment();
        let expires_at = now.add(3599, 'seconds');
        localStorage.setItem("accessToken", authResult.accessToken);
        localStorage.setItem("profile", JSON.stringify(profile));
        localStorage.setItem("expires_at", expires_at.toISOString());

        //navigate('/payment')
        this.props.setStepTwo()
            }.bind(this));
    }.bind(this))
    //

    this.props.closeModal;
    this.props.closeBottom
  }



  componentWillUnmount(){
    //
    lock.hide();


  }

  render() {

    return (


      <Div id='pop-lock-container' >

      </Div>


    )
  }
}
